<template>
  <base-layout>
    <div class="height-100 clearfix Report-edit-section">
      <h4 class="header-label" v-if="isEdit">Edit FDNS Visit</h4>
      <h4 class="header-label" v-else>Report FDNS Visit</h4>

      <div class="clearfix back-color" id="scrollableDiv" style="height: calc(100% - 131px)">
        <!-- Edit -->
        <template v-if="isEdit">
          <div class="row m0">
            <template v-if="isHRManager">
                <div class="EmployeeSQ-details clearfix">
                  <div class="col-md-3">
                    <div class="form-group m0">
                      <label>Full Name</label>
                      <p class="name-txt" :title="NAOrValue(selectedReportDetails.FdnsModel.Employee, 'ConsultantName')">{{NAOrValue(selectedReportDetails.FdnsModel.Employee, 'ConsultantName')}}</p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group m0">
                      <label>Email Address</label>
                      <p class="name-txt" :title="NAOrValue(selectedReportDetails.FdnsModel.Employee, 'EmailAddress')">{{NAOrValue(selectedReportDetails.FdnsModel.Employee, 'EmailAddress')}}</p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group m0">
                      <label>Designation</label>
                      <p class="name-txt" :title="NAOrValue(selectedReportDetails.FdnsModel.Employee, 'Designation')">{{NAOrValue(selectedReportDetails.FdnsModel.Employee, 'Designation')}}</p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group m0">
                      <label>Tax Terms</label>
                      <p class="name-txt" :title="NAOrValue(selectedReportDetails.FdnsModel.Employee, 'TaxTerms')">{{NAOrValue(selectedReportDetails.FdnsModel.Employee, 'TaxTerms')}}</p>
                    </div>
                  </div>
                </div>
              </template>
          </div>

          <div class="row m0">
            <div class="row m0">
              <div class="EmployeeSQ-details clearfix pB0">
                <div class="col-md-3">
                  <p class="offer-label label-txt">Visit Date<span style="color:red">*</span></p>
                  <div class="form-group" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitDate.$error}">
                    <ob-date-time-picker ref="dateFrom" id="visitdate" @updated="(v) => this.fdnsReportVisit.visitDate = v" :inputvalue="fdnsReportVisit.visitDate" :options="options4" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitDate.$error }"></ob-date-time-picker>
                    <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitDate.$dirty && !$v.fdnsReportVisit.visitDate.required">Please enter Visit Date</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <p class="offer-label label-txt">Visit Officer Name<span style="color:red">*</span></p>
                  <div class="form-group m0" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitOfficerName.$error}">
                    <ob-input placeholder="Visit Officer Name" v-formi9-name v-model="fdnsReportVisit.visitOfficerName" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitOfficerName.$error }" @input="updateValue(fdnsReportVisit.visitOfficerName)"></ob-input>
                    <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitOfficerName.$dirty && !$v.fdnsReportVisit.visitOfficerName.required">Please enter Visit Officer Name</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <p class="offer-label label-txt">Visit Officer Email</p>
                  <div class="form-group m0" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitOfficerEmail.$error}">
                    <ob-input placeholder="Visit Officer Email" v-model="fdnsReportVisit.visitOfficerEmail" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitOfficerEmail.$error }"></ob-input>
                    <!--<span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitOfficerEmail.$dirty && !$v.fdnsReportVisit.visitOfficerEmail.required">Please enter Visit Officer Email</span>-->
                    <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitOfficerEmail.$dirty && !$v.fdnsReportVisit.visitOfficerEmail.email">Please enter valid email</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <p class="offer-label label-txt">Visit Location<span style="color:red">*</span></p>
                  <div class="form-group m0" placeholder="Visit Location" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitLocation.$error}">
                      <!--<location-search v-if="fdnsReportVisit != ''" :vmodelData.sync="fdnsReportVisit.visitLocation" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitLocation.$error }"></location-search>-->
                      <ob-input v-model="fdnsReportVisit.visitLocation" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitLocation.$error }"></ob-input>
                      <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitLocation.$dirty && !$v.fdnsReportVisit.visitLocation.required">Please enter Visit Location</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </template>

        <!--// End Edit -->

        <!-- Add -->
        <template v-else>
          <template v-if="spinnerEmployeeSpecificQuestion">
            <ob-spinner></ob-spinner>
          </template>
          <template v-else>
            <div class="row m0">
              <template v-if="isHRManager">
                <div class="EmployeeSQ-details clearfix">
                  <div class="col-md-2" v-if="selectCandidateData.data.length > 1">
                    <div class="form-group m0">
                      <label>Select Candidate</label>
                      <ob-select2 ref="selectCandidateDrop" :options="selectCandidateData" :initialData ="initialSelectCandidateData" v-model="questionCategorydroplist" @input="questionCategorydropChange"></ob-select2>
                      <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="questionCategorydroplist ==''">Please select a candidate to see Employee specific questions</p>
                    </div>
                  </div>
                  <div v-if="questionCategorydroplist !=''">
                  <div class="col-md-2">
                    <div class="form-group m0">
                      <label>Full Name</label>
                      <p class="name-txt" :title="dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'ConsultantName'):'N/A'">{{dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'ConsultantName'):'N/A'}}</p>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group m0">
                      <label>Email Address</label>
                      <p class="name-txt" :title="dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'EmailAddress'):'N/A'">{{dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'EmailAddress'):'N/A'}}</p>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group m0">
                      <label>Designation</label>
                      <p class="name-txt" :title="dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'Designation'):'N/A'">{{dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'Designation'):'N/A'}}</p>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group m0">
                      <label>Tax Terms</label>
                      <p class="name-txt" :title="dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'TaxTerms'):'N/A'">{{dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'TaxTerms'):'N/A'}}</p>
                    </div>
                  </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row m0">
                  <div class="EmployeeSQ-details clearfix">
                    <div class="col-md-2" v-if="selectCandidateData.data.length > 1">
                      <div class="form-group m0">
                        <label>Select Organization</label>
                        <ob-select2 :options="selectCandidateData" v-model="questionCategorydroplist" @input="organizationChange"></ob-select2>
                        <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="questionCategorydroplist ==''">Please select a organization to see questions</p>
                      </div>
                    </div>
                    <template v-if="questionCategorydroplist !=''">
                      <div class="col-md-2">
                        <div class="form-group m0">
                          <label>Organization Name</label>
                          <p class="name-txt" :title="dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'OrgName'):'N/A'">{{dataBasedOnSelectCandidate != null ? getQuestionCategoryDetails(dataBasedOnSelectCandidate,'OrgName'):'N/A'}}</p>
                        </div>
                      </div>
                      <div class="col-md-2" >
                        <div class="form-group m0">
                          <label>Organization Website</label>
                          <p class="name-txt" v-html="dataBasedOnSelectCandidate.WebSite == '' ? 'N/A' : `<a href='${dataBasedOnSelectCandidate.WebSite}' title='${dataBasedOnSelectCandidate.WebSite}' target='_blank'>${dataBasedOnSelectCandidate.WebSite}</a>`"></p>
                        </div>
                      </div>
                      <div class="col-md-4" >
                        <div class="form-group m0">
                          <label>Organization Address</label>
                          <p class="name-txt">{{dataBasedOnSelectCandidate.Address =="" ? 'N/A':dataBasedOnSelectCandidate.Address }}</p>
                          </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <div class="row m0" v-if="questionCategorydroplist !=''">
              <div class="EmployeeSQ-details clearfix pB0">
                <div class="col-md-2">
                  <p class="offer-label label-txt">Visit Date<span style="color:red">*</span></p>
                  <div class="form-group" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitDate.$error}">
                    <ob-date-time-picker ref="dateFrom" id="visitdate" @updated="(v) => this.fdnsReportVisit.visitDate = v" :inputvalue="fdnsReportVisit.visitDate" :options="options4" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitDate.$error }"></ob-date-time-picker>
                    <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitDate.$dirty && !$v.fdnsReportVisit.visitDate.required">Please enter Visit Date</span>
                  </div>
                </div>
                <div class="col-md-3 ">
                  <p class="offer-label label-txt">Visit Officer Name<span style="color:red">*</span></p>
                  <div class="form-group m0" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitOfficerName.$error}">
                    <ob-input placeholder="Visit Officer Name" v-formi9-name v-model="fdnsReportVisit.visitOfficerName" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitOfficerName.$error }" @input="updateValue(fdnsReportVisit.visitOfficerName)"></ob-input>
                    <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitOfficerName.$dirty && !$v.fdnsReportVisit.visitOfficerName.required">Please enter Visit Officer Name</span>
                  </div>
                </div>
                  <div class="col-md-3">
                  <p class="offer-label label-txt">Visit Officer Email</p>
                  <div class="form-group m0" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitOfficerEmail.$error}">
                    <ob-input placeholder="Visit Officer Email" v-model="fdnsReportVisit.visitOfficerEmail" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitOfficerEmail.$error }"></ob-input>
                    <!--<span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitOfficerEmail.$dirty && !$v.fdnsReportVisit.visitOfficerEmail.required">Please enter Visit Officer Email</span>-->
                    <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitOfficerEmail.$dirty && !$v.fdnsReportVisit.visitOfficerEmail.email">Please enter valid email</span>
                  </div>
                </div>
                <div class="col-md-3 ">
                  <p class="offer-label label-txt">Visit Location<span style="color:red">*</span></p>
                  <div class="form-group m0" placeholder="Visit Location" v-bind:class="{'ob-vuelidate_error-msg':$v.fdnsReportVisit.visitLocation.$error}">
                      <!--<location-search v-if="fdnsReportVisit != ''" :vmodelData.sync="fdnsReportVisit.visitLocation" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitLocation.$error }"></location-search>-->
                      <ob-input v-model="fdnsReportVisit.visitLocation" v-bind:class="{ 'ob-vuelidate_input-error': $v.fdnsReportVisit.visitLocation.$error }"></ob-input>
                      <span class="ob-vuelidate_error-msg" v-if="$v.fdnsReportVisit.visitLocation.$dirty && !$v.fdnsReportVisit.visitLocation.required">Please enter Visit Location</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <!--// End Add -->

        <!-- Add Question message -->
        <div class="row" v-if="QuestionList && QuestionList.length > 0" :class="{'edit-class-padding':isEdit}">
            <div class="col-md-10">
              <p class="alert-fdnsreport"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/warning-red-alert.svg`" style="height: 14px;padding-right: 5px;">Select the question asked by auditor during FDNS Visit interview and Add Question if it is not listed below</p>
            </div>
            <div class="col-md-2">
              <ob-button @click="isAddQuestion" v-if="$route.name != 'ess-fdns-visit-history'">Add Question</ob-button>
            </div>
          </div>
        <!--// End Add Question message -->


        <!-- Question starts -->
        <div v-if="questionCategorydroplist !=''">
          <template v-if="spinnerEmployeeQuestionselected == true">
            <ob-spinner></ob-spinner>
          </template>
          <template v-else>
            <div v-if="QuestionList && QuestionList.length > 0">
              <list :validate="validate" :scrollableOffsetDiff="175" scrollableDivID="scrollableDiv" :QuestionCategoryList="QuestionCategoryList" :QuestionList="QuestionList" :OrgId="OrgId" :IsFDNSVisit="true" :selectedData.sync="selectedData"></list>
              <div class="text-left btn-footer-sticky">
                <ob-button type="secondary" @click="$router.push({name: 'ess-fdns-visit-history'})">Cancel</ob-button>
                <ob-button type="primary" @click="onSave" :disabled="selectedData.length == 0">{{ isEdit ? 'Update' : 'Save'}}</ob-button>
              </div>
            </div>
            <div class="MT-Content-table" v-else>
              <div class="MT-Content">No FDNS data</div>
            </div>
          </template>
        </div>
        <div class="text-left btn-footer-sticky">
          <ob-button type="secondary" @click="$router.push({name: 'ess-fdns-visit-history'})">Cancel</ob-button>

          <!-- Workaround for showing tooltip when the buttons are disabled-->
          <template v-if="selectedData.length == 0">
            <ob-button type="primary" :disabled="true">
              <span v-tooltip="{ content: 'Please select a question', visible: selectedData.length == 0 }">{{ isEdit ? 'Update' : 'Save'}}</span>
            </ob-button>
          </template>
          <template v-else>
            <ob-button type="primary" @click="onSave">{{ isEdit ? 'Update' : 'Save'}}</ob-button>
          </template>
        </div>
        <!-- Question ends -->
      </div>
      <fdns-report-addquestion-popup :openAddQuestionPopUp.sync="toOpenAddQuestionPopUp" @questionAdded="onQuestionAdded"></fdns-report-addquestion-popup>
    </div>
  </base-layout>
</template>
<script>
import namevalidation from "Vue/Core/namevalidation.js"
import utils from '@/components/Core/utils.js'
import List from "./QA/List.vue";
import AddQuestionPopUp from "./FDNS-PopUp/AddQuestions.vue";
import {
  required,
  requiredIf,
  maxLength,
  alpha,
  email,
  minValue
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      validate: false,
      selectedData: [],
      OrgId: "",
      questionCategorydroplist: "",
      toOpenviewProfileSummaryPopUp: false,
      spinnerEmployeeSpecificQuestion: false,
      changeSelectCandidateData: "",
      dataBasedOnSelectCandidate: "",
      toOpenAddQuestionPopUp: false,
      spinnerEmployeeQuestionselected: false,
      initialSelectCandidateData: [],
      selectCandidateData: {
        placeholder: {
          id: "-1",
          text: "Select Candidate"
        },
        data: []
      },
      employeeNameOption: {
        data: []
      },
      questionTypeData: "",
      addQuestionData: {
        QuestionTitle: "",
        Answer: "",
        questionCategory: "",
        questionType: ""
      },
      fdnsReportVisit: {
        visitDate: "",
        visitOfficerName: "",
        visitOfficerEmail: "",
        visitLocation: ""
      },
      validate: false,
      isValid: true,
      options4: {
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        //maxDate: moment().subtract(0, 'days'),
        widgetPositioning: {
          horizontal: "left",
          vertical: "bottom"
        }
      }
    };
  },
  validations() {
    return {
      fdnsReportVisit: {
        visitDate: {
          required
        },
        visitOfficerName: {
          required
        },
        visitOfficerEmail: {
          //required,
          email
        },
        visitLocation: {
          required
        }
      }
    };
  },
  computed: {
    selectedReportDetails() {
      return this.$store.getters.getFDNSSelectedReportDetails;
    },
    isEdit() {
      return this.$route.query && this.$route.query.type == "Edit";
    },
    isFormValid() {
      if (this.selectedData.length > 0) {
        let valid = true;
        this.selectedData.forEach(s => {
          if (s.Answer == null || s.Answer == "") {
            valid = false;
          }
        });

        return valid;
      } else {
        return false;
      }
    },
    QuestionCategoryList() {
      return this.$store.getters.getFDNSQuestionCategoryList;
    },
    QuestionList: {
      get() {
        return this.$store.getters.getFDNSQuestionList;
      },

      set(v) {
        this.$store.commit("updateFDNSQuestionList", v);
      }
    }
  },
  created() {
    if (!this.isEdit) {
      this.$store.commit("updateFDNSResetFDNSStore");
    }
    this.init();
  },
  components: {
    list: List,
    "fdns-report-addquestion-popup": AddQuestionPopUp
  },
  methods: {
    updateValue(value){
      let val = namevalidation.getValidName(value);
      this.fdnsReportVisit.visitOfficerName = val
    },
     IsNAOrValue(obj, key) {
        if(obj && !utils.IsNullOrEmpty(obj[key])) {
          return obj[key]
        }

        return 'N/A'
      },
    // Copy the data from selected data to the default questions
    copySelectedDataToDefaultQuestions(temp) {
      if (this.selectedData && this.selectedData.length > 0) {
        let index = -1;
        temp.forEach(t => {
          index = this.selectedData.findIndex(d => d.Id == t.Id);
          if (index != -1) {
            t.Answer = this.selectedData[index].Answer;
          }
        });
      }
    },
    // Check whether the new list has the already
    // selected questions if not remove it
    updateSelectedData(arr) {
      let selected = [];
      this.selectedData.forEach(s => {
        if (arr.findIndex(a => a.Id == s.Id) !== -1) {
          selected.push(s);
        }
      });

      this.selectedData = selected;
    },
    onQuestionAdded(type) {
      if (this.isEdit) {
        this.getAllQuestionsForEdit();
      } else {
        this.reloadQuestions();
      }
    },
    reloadQuestions() {
      if (this.isHRManager) {
        if (
          this.questionCategorydroplist &&
          this.questionCategorydroplist != ""
        ) {
          this.questionCategorydropChange(this.questionCategorydroplist);
        }
      } else if (this.isConsultant) {
        if (
          this.questionCategorydroplist &&
          this.questionCategorydroplist != ""
        ) {
          this.organizationChange(this.questionCategorydroplist);
        }
      }
    },
    isAddData() {
      this.$v.addQuestionData.$touch();
      if (this.$v.addQuestionData.$invalid != true) {
        alert();
      }
    },
    viewProfileSummaryPopup() {
      this.toOpenviewProfileSummaryPopUp = true;
    },
    init() {
      if (this.isEdit) {
        // For Edit
        // todo

        this.fdnsReportVisit.visitDate = this.selectedReportDetails.FdnsModel.VisitOfficerDate;
        this.fdnsReportVisit.visitLocation = this.selectedReportDetails.FdnsModel.VisitOfficerLocation;
        this.fdnsReportVisit.visitOfficerName = this.selectedReportDetails.FdnsModel.VisitOfficerName;
        this.fdnsReportVisit.visitOfficerEmail = this.selectedReportDetails.FdnsModel.VisitOfficerEmail;

        this.dataBasedOnSelectCandidate = this.selectedReportDetails.FdnsModel.Employee;

        this.selectedData = this.selectedReportDetails.QuestionList;

        this.questionCategorydroplist = this.selectedReportDetails.FdnsModel.Employee.ConsultantId;
        this.spinnerEmployeeSpecificQuestion = false;

        this.getAllQuestionsForEdit();
      } else {
        //reset
        this.questionCategorydroplist = "";
        this.dataBasedOnSelectCandidate = "";
        this.spinnerEmployeeSpecificQuestion = true;
        if (this.isHRManager) {
          this.initHR();
        } else if (this.isConsultant) {
          this.initJobSeeker();
        } else {
          this.$message({
            type: "error",
            message: "Error"
          });
        }
      }
    },

    initHR() {
      ajax.get(`/OnBoarding/GetEmployeeList`, {}, res => {
        if (res.data.State == true) {
          this.spinnerEmployeeSpecificQuestion = false;
          this.changeSelectCandidateData = res.data.resultList;
          this.selectCandidateData.data = __.map(res.data.resultList, t => {
            return {
              id: t.ConsultantId,
              text: t.ConsultantName,
              detailedData: t
            };
          });

          // load the first candidate questions by default
          if (res.data.resultList.length > 0) {
            let firstConsultantId = res.data.resultList[0].ConsultantId;

            this.questionCategorydroplist = firstConsultantId;
            this.questionCategorydropChange(firstConsultantId);
          }
        } else {
          //this.ESSEnableDisable(res)
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },

    initJobSeeker() {
      ajax.get(`/OnBoarding/GetAllMyEmployerList`, {}, res => {
        if (res.data.State == true) {
          this.spinnerEmployeeSpecificQuestion = false;
          this.changeSelectCandidateData = res.data.resultList;
          this.selectCandidateData.data = __.map(res.data.resultList, t => {
            return {
              id: t.OrgId,
              text: t.OrgName,
              detailedData: t
            };
          });

          // load the first organization questions by default
          if (res.data.resultList.length > 0) {
            let firstOrgId = res.data.resultList[0].OrgId;

            this.questionCategorydroplist = firstOrgId;
            this.organizationChange(firstOrgId);
          }
        } else {
          this.ESSEnableDisable(res)
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },

    getAllQuestionsForEdit() {
      this.spinnerEmployeeQuestionselected = true;

      if (this.isConsultant) {
        ajax.get(
          `/FDNSAudit/GetEmployeeSpecificQuestions?consultantId=${
            this.$store.getters.getFDNSSelectedReportDetails.FdnsModel.Employee
              .ConsultantId
          }&empOrgId=${this.$store.getters.getFDNSSelectedReport.empOrgId}&isESS=true`,
          {},
          res => {
            if (res.data.State == true) {
              let temp = res.data.resultList;

              // Copy the data from selected data to the default questions
              this.copySelectedDataToDefaultQuestions(temp);
              this.QuestionList = temp;

              this.spinnerEmployeeQuestionselected = false;
            } else {
              this.ESSEnableDisable(res)
              this.$message({
                type: "error",
                message: res.data.Message
              });
            }
          }
        );
      } else if (this.isHRManager) {
        // Query Employer Questions
        ajax.get(`/FDNSAudit/GetEmployerQuestions`, {}, res => {
          if (res.data.State == true) {
            let temp1 = res.data.resultList;

            // Query Employee Specific Questions
            ajax.get(
              `/FDNSAudit/GetEmployeeSpecificQuestions?consultantId=${
                this.$store.getters.getFDNSSelectedReportDetails.FdnsModel
                  .Employee.ConsultantId
              }&empOrgId=${this.$store.getters.getFDNSSelectedReport.empOrgId}`,
              {},
              res => {
                if (res.data.State == true) {
                  let temp = temp1.concat(res.data.resultList);

                  // Copy the data from selected data to the default questions
                  this.copySelectedDataToDefaultQuestions(temp);
                  this.QuestionList = temp;

                  this.spinnerEmployeeQuestionselected = false;
                } else {
                  //this.ESSEnableDisable(res)
                  this.$message({
                    type: "error",
                    message: res.data.Message
                  });
                }
              }
            );
          } else {
            this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        });
      }
    },

    organizationChange(i) {
      this.OrgId = i;
      this.changeSelectCandidateData.forEach(o => {
        if (o.OrgId == i) {
          this.dataBasedOnSelectCandidate = o;
          this.spinnerEmployeeQuestionselected = true;

          this.$store.commit("updateFDNSConsultantId", this.loggedInUserObj.Id);
          this.$store.commit("updateFDNSEmpOrgId", i);

          ajax.get(
            `/FDNSAudit/GetEmployeeSpecificQuestions?consultantId=${
              this.loggedInUserObj.consultantId
            }&empOrgId=${i}`,
            {},
            res => {
              if (res.data.State == true) {
                // Copy the data from selected data to the default questions
                this.copySelectedDataToDefaultQuestions(res.data.resultList);

                // update selected data
                this.updateSelectedData(res.data.resultList);

                this.$store.commit(
                  "updateFDNSQuestionList",
                  res.data.resultList
                );

                this.spinnerEmployeeQuestionselected = false;
              } else {
                this.ESSEnableDisable(res)
                this.$message({
                  type: "error",
                  message: res.data.Message
                });
              }
            }
          );
        }
      });
    },

    questionCategorydropChange(i) {
      if (this.changeSelectCandidateData != "") {
        this.changeSelectCandidateData.forEach(o => {
          if (o.ConsultantId == i) {
            this.dataBasedOnSelectCandidate = o;
            this.spinnerEmployeeQuestionselected = true;

            this.$store.commit("updateFDNSConsultantId", i);
            this.$store.commit(
              "updateFDNSEmpOrgId",
              this.loggedInUserObj.OrgId
            );

            // Query Employer Questions
            ajax.get(`/FDNSAudit/GetEmployerQuestions`, {}, res => {
              if (res.data.State == true) {
                let temp1 = res.data.resultList;

                // Query Employee Specific Questions
                ajax.get(
                  `/FDNSAudit/GetEmployeeSpecificQuestions?consultantId=${i}&empOrgId=${
                    this.loggedInUserObj.OrgId
                  }`,
                  {},
                  res => {
                    if (res.data.State == true) {
                      let temp = temp1.concat(res.data.resultList);

                      // Copy the data from selected data to the default questions
                      this.copySelectedDataToDefaultQuestions(temp);

                      // update selected data
                      this.updateSelectedData(temp);

                      this.$store.commit("updateFDNSQuestionList", temp);

                      this.spinnerEmployeeQuestionselected = false;
                    } else {
                      this.ESSEnableDisable(res)
                      this.$message({
                        type: "error",
                        message: res.data.Message
                      });
                    }
                  }
                );
              }
            });
          }
        });
      }
    },

    getQuestionCategoryDetails(questionCategoryValues, key) {
      if (questionCategoryValues != "" && questionCategoryValues[key] != null) {
        let docData = questionCategoryValues;
        let keyData = key;
        return docData[keyData];
      }

      return "N/A";
    },
    isAddQuestion() {
      this.toOpenAddQuestionPopUp = true;
    },
    onSave() {
      this.validate = true;
      this.$v.fdnsReportVisit.$touch();

      if (
        this.isFormValid == true &&
        this.$v.fdnsReportVisit.$invalid != true
      ) {
        this.$loading({
          loadingText: "Loading..."
        });
        let params = {
          Employee: {
            ConsultantId: this.dataBasedOnSelectCandidate.ConsultantId,
            ConsultantName: this.dataBasedOnSelectCandidate.ConsultantName,
            Designation: this.dataBasedOnSelectCandidate.Designation,
            EmailAddress: this.dataBasedOnSelectCandidate.EmailAddress,
            PhoneNumber: this.dataBasedOnSelectCandidate.PhoneNumber,
            TaxTerms: this.dataBasedOnSelectCandidate.TaxTerms,
            HomeAddress: this.dataBasedOnSelectCandidate.HomeAddress
          },
          VisitOfficerName: this.fdnsReportVisit.visitOfficerName,
          VisitOfficerLocation: this.fdnsReportVisit.visitLocation,
          VisitOfficerDate: this.fdnsReportVisit.visitDate,
          VisitOfficerEmail: this.fdnsReportVisit.visitOfficerEmail,
          FDNSQuestions: this.selectedData
        };
        if (this.isEdit) {
          params.ReportId = this.$route.query.RepId;
        } else {
          params.ReportId = null;
        }

        let OrgDataId = "";
        if (this.isConsultant) {
          OrgDataId = this.$store.getters.getFDNSEmpOrgId;
        }
        ajax.post(
          `/FDNSAudit/AddOrEditFDNSReport?empOrgId=${OrgDataId}`,
          params,
          res => {
            this.$loading({}).close();
            if (res.data.State == true) {
              this.$message({
                type: "success",
                message: "Report save successfully"
              });
              this.$router.push({ name: "ess-fdns-visit-history" });
            } else {
              this.ESSEnableDisable(res)
              this.$message({
                type: "error",
                message: res.data.Message
              });
            }
          }
        );
      }
    }
  }
};
</script>
<style scoped lang="scss">
//  header section START
.header-label {
  color: #143361;
  font-weight: 600;
  margin: 0px;
  font-size: 17px;
  line-height: 31px;
  padding: 0px 14px 14px 14px;
}

.left-section-search {
  width: 25%;
  float: left;
}

.right-section-search {
  width: 75%;
  display: inline-block;
  text-align: right;
}

.search-field-bar {
  width: 30%;
  display: inline-block;
}

.search-btn-field {
  margin-left: -6px;
  margin-bottom: 2px;
} //  header section END
//Main Section start
.answer-txt {
  display: block;
  margin: 10px 0;
  width: 100%;
  margin-left: 15px;
}

.manual-txt {
  display: inline;
  color: #b3b2bb;
  font-size: 13px;
  font-weight: 600;
}
/* Change color of dropdown links on hover */

.heading-txt {
  padding: 15px 15px 15px 22px;
  border-bottom: 1px solid #4a90e3;
  position: -webkit-sticky;
  position: sticky;
  top: -15px;
  background: #fff;
  z-index: 1;
  p {
    color: #4a90e3;
    font-size: 16px;
    font-weight: 600;
  }
}

.Fdns-audit-fluid {
  padding: 0px 20px 0 20px;
}

.fdnsaudit-container {
  background: #fff;
}

.fdns-footer {
  padding: 0 0 20px 0;
  text-align: center;
} // TABS STARTS
.fdns-header_tabs {
  margin: 20px 0 0 0;
  ul {
    padding: 0;
    width: 60%;
    display: inline-block;
    li {
      list-style: none;
      display: inline;
      padding: 7px 0px 7px 20px;
      a {
        font-size: 16px;
        font-weight: 600;
        color: #b0b2b5;
      }
    }
    li.active {
      border-bottom: 3px solid #2d4972;
      a {
        color: #143361;
      }
    }
  }
}

.fdns-header-tabs-right {
  text-align: right;
  width: 39%;
  display: inline-block;
} // TABS ENDS
//Add Question popup start
textarea {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  width: 100%;
  height: 90px;
  resize: none;
  color: #555555;
}

.modal-pad {
  padding: 35px;
}

.questiontypebase {
  margin-top: 15px;
}

.ob-margin-no {
  margin-top: 15px;
}

.name-txt {
  color: #30303f;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.EmployeeSQ-details {
  background: #fff;
  padding: 15px 0 15px 0;
}

.MT-Content-table {
  height: auto;
  display: table;
  width: 100%;
}

.MT-Content {
  margin-top: 2%;
  text-align: center;
  width: 100%;
  display: block;
  vertical-align: middle;
  font-weight: 600;
}

.alert-fdnsreport {
  color: #d60000;
  font-size: 12px;
  background: #fff;
  font-weight: 600;
  padding-left: 15px;
}

.height-100 {
  height: 100%;
}

.back-color {
  background: #fff;
  overflow: auto;
  overflow-x: hidden;
}

.fdns-footer {
  padding: 0 0 20px 0;
  text-align: center;
}
.edit-class-padding {
  padding-top: 10px;
}

//Add Question popup end
</style>
<style lang="scss">
.Report-edit-section {
  .fixed-dropdown {
    position: fixed;
    right: 37px !important;
    top: 313px !important;
    z-index: 2;
  }
}
.btn-footer-sticky {
  bottom: 40px;
  width: calc(100% - 100px);
  position: fixed;
  background: #fff;
  z-index: 1;
  padding: 18px 0 12px 20px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/ReportFDNSVisit.vue